import React, { useRef } from "react";
import { Modal, Table } from "react-bootstrap";
import Logo from "../../../../../assets/imgs/logo-azul.svg";
import "./auditor.css";

function TicketModal({ show, onHide, data }) {
  const printRef = useRef();

  const printTicket = () => {
    const printContent = printRef.current;
    if (!printContent) return;

    const printWindow = window.open("", "_blank", "width=800,height=1000");
    if (!printWindow) {
      alert("Por favor, permite las ventanas emergentes.");
      return;
    }

    // Estilos para impresión full-page (cero márgenes, tamaño exacto)
    const printStyles = `
    <style>
      /* Estilos generales */
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }

      body {
        font-family: 'Courier New', monospace, 'Segoe UI', sans-serif;
        font-size: 12px;
        line-height: 1.3;
        color: #000;
        background: #fff;
        /* Forzar impresión de colores y fondos */
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }

      /* Ajuste principal: el contenedor del ticket */
      .print-container {
        width: 100%;
        min-height: 100vh;
        padding: 0 !important;
        margin: 0 !important;
      }

      /* Estilo del ticket: ajustar ancho según necesidad */
      .ticket {
        width: 100%;
        max-width: none !important;
        margin: 0 !important;
        padding: 15px 10px !important;
        border: none !important;
        background: white !important;
        page-break-inside: avoid;
      }

      /* Tablas: bordes visibles al imprimir */
      table {
        width: 100%;
        border-collapse: collapse !important;
        margin: 8px 0;
      }
      th, td {
        border: 1px solid black !important;
        padding: 6px 4px !important;
        text-align: center;
        font-size: 12px;
      }
      th {
        background-color: #030c41 !important;
        color: white !important;
      }

      hr {
        border: 0;
        border-top: 1px dashed #000;
        margin: 8px 0;
      }

      img {
        max-width: 100%;
        height: auto;
      }

      /* Eliminar márgenes de impresión del navegador */
      @page {
        size: auto; /* o usa '80mm 300mm' para ticket térmico */
        margin: 0 !important;
      }

      @media print {
        html, body {
          width: 100%;
          height: 100%;
          margin: 0 !important;
          padding: 0 !important;
          overflow: hidden;
        }
        .print-container {
          height: auto;
          min-height: unset;
        }
      }
    </style>
  `;

    // Bootstrap CSS (solo si necesitas clases como 'text-center', 'fw-bold', etc.)
    // Si no lo usas, puedes quitarlo para hacerlo más ligero
    const bootstrapCDN = `
    <link 
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" 
      rel="stylesheet"
      integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH"
      crossorigin="anonymous"
    >
  `;

    const printDocument = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <title>Ticket</title>
        ${bootstrapCDN}
        ${printStyles}
      </head>
      <body>
        <div class="print-container">
          <div class="ticket">
            ${printContent.innerHTML}
          </div>
        </div>
        <script>
          window.onload = () => {
            setTimeout(() => {
              window.print();
              window.onafterprint = () => window.close();
            }, 300);
          };
        </script>
      </body>
    </html>
  `;

    printWindow.document.open();
    printWindow.document.write(printDocument);
    printWindow.document.close();
  };

  return (
    <Modal show={show} onHide={onHide} className="ticket-Modal" centered>
      <Modal.Header
        closeButton
        style={{ background: "#020C41", color: "white" }}
      >
        <Modal.Title>Impresión de ticket</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div ref={printRef} id="cubiTicket" style={{ padding: "25px" }}>
          <div
            className="ticket border p-4"
            style={{ width: "100%", margin: "0 auto" }}
          >
            {/* LOGO */}
            <p className="text-center">
              <img src={Logo} alt="LOGO" width="50%" />
            </p>

            <hr />

            <div className="text-center">
              <p>Aerovias de México S.A. de C.V.</p>
              <p>AME880912I89</p>
              <p>Col Cuauhtemoc C.P. 06500 Ciudad de México</p>
              <p>Paseo de la Reforma 243 Piso 25</p>
            </div>

            <hr />

            {/* DATOS DE MASTER */}
            <Table bordered size="sm">
              <thead>
                <tr>
                  <th
                    colSpan={3}
                    className="text-center"
                    style={{ backgroundColor: "#030c41", color: "white" }}
                  >
                    Datos de master
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={3} className="text-center fw-bold">
                    {data.awb}
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                    }}
                  >
                    Piezas
                  </td>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderLeft: "none",
                    }}
                  >
                    {data.pieces}
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                    }}
                  >
                    Gross WT
                  </td>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderLeft: "none",
                    }}
                  >
                    {Number(data.weight).toFixed(2)} kg
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                    }}
                  >
                    CH WT
                  </td>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderLeft: "none",
                    }}
                  >
                    {Number(data.chargeable_weight).toFixed(2)} kg
                  </td>
                </tr>
              </tbody>
            </Table>

            <hr />

            {/* VERIFICACIÓN DE PESO */}
            <Table bordered size="sm">
              <thead>
                <tr>
                  <th
                    colSpan={3}
                    className="text-center"
                    style={{ backgroundColor: "#030c41", color: "white" }}
                  >
                    Verificación de peso
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                    }}
                  >
                    Gross WT
                  </td>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderLeft: "none",
                    }}
                  >
                    {Number(data.cubGrossWt).toFixed(2)} kg
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                    }}
                  >
                    Volumen
                  </td>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderLeft: "none",
                    }}
                  >
                    {data.cubeVol} m³
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                    }}
                  >
                    CH WT
                  </td>
                  <td
                    className="text-center"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderLeft: "none",
                    }}
                  >
                    {Number(data.cubChWt).toFixed(2)} kg
                  </td>
                </tr>
              </tbody>
            </Table>

            <hr />

            {/* MENSAJE FINAL */}
            <p className="text-center mt-3 fw-bold">
              {data.tolerance == 0 &&
                "Valores aceptados, se cobra conforme los datos de la guía."}
              {data.tolerance == 1 &&
                "Medición fuera de rango: Valores excedidos, se requiere cambio de documentos."}
              {data.tolerance == -1 &&
                "Medición fuera de rango: Acepto que se cobre conforme a los datos asentados en la guía."}
            </p>

            <br />
            <br />
            <br />

            {/* FIRMAS */}
            <div className="mt-2">
              <hr />
              <p className="text-center">FIRMA CLIENTE</p>
            </div>

            <br />
            <br />
            <br />

            <div className="mt-4">
              <hr />
              <p className="text-center">FIRMA AGENTE</p>
            </div>
          </div>
        </div>

        <div className="text-end mt-4">
          <button className="btnn" onClick={() => printTicket("cubiTicket")}>
            Imprimir
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default TicketModal;
